import _each from "lodash/each";

export default class EcModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        isSP: false,
        photoNum: 0,
        enlargedImage: false,
        selectColorNum: "",
        buttonState: "",
        sizeGuideModal: false,
        contactModal: false,
        arrivalNotificationModal: false,
        miniCartModal: false,
        vimeoModal: false,
        globalUsersModal: false,
        selectSize: "",
        optionItem: {
          target: "",
          label: "",
          value: ""
        }
      },

      getters: {
        isSP: (state) => (sta) => {
          return state.isSP;
        },
        photoNum: (state) => (num) => {
          return state.photoNum;
        },
        enlargedImage: (state) => (sta) => {
          return state.enlargedImage;
        },
        selectColorNum: (state) => (num) => {
          return state.selectColorNum;
        },
        buttonState: (state) => (sta) => {
          return state.buttonState;
        },
        sizeGuideModal: (state) => (sta) => {
          return state.sizeGuideModal;
        },
        contactModal: (state) => (sta) => {
          return state.contactModal;
        },
        arrivalNotificationModal: (state) => (sta) => {
          return state.arrivalNotificationModal;
        },
        miniCartModal: (state) => (sta) => {
          return state.miniCartModal;
        },
        vimeoModal: (state) => (sta) => {
          return state.vimeoModal;
        },
        globalUsersModal: (state) => (sta) => {
          return state.globalUsersModal;
        },
        selectSize: (state) => (sta) => {
          return state.selectSize;
        },
        optionItem: (state) => (sta) => {
          return state.optionItem;
        }
      },

      // Mutations ----------------------------------------
      mutations: {
        setIsSP(state, sta) {
          state.isSP = sta;
        },
        setPhotoNum(state, num) {
          state.photoNum = num;
        },
        setEnlargedImage(state, sta) {
          state.enlargedImage = sta;
        },
        setColorNum(state, num) {
          state.selectColorNum = num;
        },
        setButtonState(state, sta) {
          state.buttonState = sta;
        },
        setSizeGuideModal(state, sta) {
          state.sizeGuideModal = sta;
        },
        setContactModal(state, sta) {
          state.contactModal = sta;
        },
        setArrivalNotificationModal(state, sta) {
          state.arrivalNotificationModal = sta;
        },
        setMiniCartModal(state, sta) {
          state.miniCartModal = sta;
        },
        setVimeoModal(state, sta) {
          state.vimeoModal = sta;
        },
        setGlobalUsersModal(state, sta) {
          state.globalUsersModal = sta;
        },
        setSize(state, num) {
          state.setSize = num;
        },
        setSearchOptionItem(state, payload) {
          state.optionItem.value = payload.value;
          state.optionItem.label = payload.label;
          state.optionItem.target = payload.target;
        }
      },
      // Actions ----------------------------------------
      actions: {
        setIsSP({ commit, state }, payload) {
          commit("setIsSP", payload.sta);
        },
        setPhotoNum({ commit, state }, payload) {
          commit("setPhotoNum", payload.num);
        },
        setEnlargedImage({ commit, state }, payload) {
          commit("setEnlargedImage", payload.sta);
        },
        setColorNum({ commit, state }, payload) {
          commit("setColorNum", payload.num);
        },
        setButtonState({ commit, state }, payload) {
          commit("setButtonState", payload.sta);
        },
        setSizeGuideModal({ commit, state }, payload) {
          commit("setSizeGuideModal", payload.sta);
        },
        setContactModal({ commit, state }, payload) {
          commit("setContactModal", payload.sta);
        },
        setArrivalNotificationModal({ commit, state }, payload) {
          commit("setArrivalNotificationModal", payload.sta);
        },
        setMiniCartModal({ commit, state }, payload) {
          commit("setMiniCartModal", payload.sta);
        },
        setVimeoModal({ commit, state }, payload) {
          commit("setVimeoModal", payload.sta);
        },
        setGlobalUsersModal({ commit, state }, payload) {
          commit("setGlobalUsersModal", payload.sta);
        },
        setSize({ commit, state }, payload) {
          commit("setSize", payload.num);
        },
        setSearchOptionItem({ commit, state }, payload) {
          commit("setSearchOptionItem", payload);
        }
      }
    };
  }

  getModule() {
    return this.module;
  }
}